module.exports = __webpack_public_path__ + "static/media/evergreen-protoype.e91c8608.jpg";